import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { ITranslateApi } from "./base/translateApi";
import { Result } from "../models/common/resultResponse";
import { TranslationCultureResponse } from "../models/response/translationCultureResponse";
import { TranslateCultureRequest } from "../models/request";

const baseRoute: string = "TranslationCulture";

export class TranslateApi extends ITranslateApi {
	getTranslates(filter: TranslateCultureRequest): Promise<AxiosResponse<Result<TranslationCultureResponse>>> {
		return api.post(`${baseRoute}/translates`, filter);
	}
}
